import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ChangeDetectorRef, HostListener } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { FiltersService } from './filters.service';
import { ActivatedRoute } from '@angular/router';
import { MainService } from '../main.service';
import { localStorageService } from '../localstorage.service';
import { SharedService } from '../shared.service';
import { ApiService } from '../api.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Filters } from '../interface.component';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit, OnChanges {

  @Output() finalValues: any = new EventEmitter();
  @Output() resetAllFilters: any = new EventEmitter();
  @Output() cancelSearched = new EventEmitter<{ title: string }>();
  public filterForm!: UntypedFormGroup;
  minDate: Date = new Date(2024, 0, 1);
  maxDate: Date = new Date();
  timezone: any;
  subIndustryFilter: any;
  public filterData: Array<Filters> = [];
  bsConfig: Partial<BsDatepickerConfig>;
  openedScoreRange: string | null = null;

  constructor(
    public fb: FormBuilder,
    public mainService: MainService,
    public filterService: FiltersService,
    private cd: ChangeDetectorRef,
    public route: ActivatedRoute,
    private _local: localStorageService,
    public _shared: SharedService,
    private _api: ApiService
  ) {
    this.timezone = this._shared.getTimezone();
    this.bsConfig = Object.assign({}, {
      containerClass: 'theme-green',
      dateInputFormat: 'MM/DD/YYYY',
      placement: 'bottom'
    });
  }

  get filters(): Array<Filters> {
    return this.filterData;
  }

  @Input() set filters(val: Array<Filters>) {
    if (val) {
      this.filterData = val;
      this.initForm(1);
    }
  }

  ngOnInit() {
    this.maxDate = new Date(this._shared.getMaxDate(this.timezone));
    this.timezone = this._shared.getTimezone();
    this.maxDate = new Date(this._shared.getMaxDate(this.timezone));
  }

  initForm(id: any): void {
    const group: any = {};
    /** To disable filter on condition initially */
    this.filterData.forEach((element: any) => {
      element.disabled = false;
      if (element.can_disable == true) {
        element.disabled_condition.forEach((ele: any) => {
          let x = this.filterData.filter((i: any) => (ele.control == i.control && (ele.value.includes(i.value)) || (ele.value == i.value)));
          if (x && x.length > 0) {
            element.disabled = true;
          }
        });
      }
      if (element.type === 'multiselect' && (!element.options || (element.options && !element.options.length))) {
        element.disabled = true;
      }
      const resetValue = element.default !== undefined ? element.default : null;
      group[element.control] = new FormControl({ value: id == 1 ? element.value : resetValue, disabled: element.disabled ? true : false });
    });
    this.filterForm = this.fb.group(group);
    this.applyHideConditions();
    console.log(this.filterForm.value);
  }

  /**
   * Fields flagged can_hide drop out of the panel while another control holds one of the
   * values listed in hide_condition — e.g. a custom date range that only belongs on screen
   * once the range dropdown says "Custom Range". Re-evaluated on every dropdown change.
   */
  private applyHideConditions(): void {
    this.filterData.forEach((element: any) => {
      if (element.can_hide !== true) {
        return;
      }
      element.hide = (element.hide_condition || []).some((condition: any) => {
        const current = String(this.controlValue(condition.control));
        return Array.isArray(condition.value)
          ? condition.value.map(String).includes(current)
          : String(condition.value) === current;
      });
    });
  }

  /** Live value of a control once the form exists, otherwise its configured starting value. */
  private controlValue(control: string): any {
    const live = this.filterForm && this.filterForm.get(control);
    if (live) {
      return live.value;
    }
    const field: any = this.filterData.find((item: any) => item.control === control);
    return field ? field.value : null;
  }

  changedate() {
    if (this.filterForm && this.filterForm.value && this.filterForm.value.webinar_date) {
      console.log("this.filterForm.value.webinar_date", this.filterForm.value.webinar_date)
      this.finalValues.emit({ data: this.filterForm.value });
    }
  }

  ngOnChanges() {
    if (this.filterForm) {
      /** To hide filter on condition at runtime (the dropdowns call this on change) */
      this.applyHideConditions();
      /** To disable filter on condition at runtime */
      this.filterData.forEach((element: any) => {
        element.disabled = false;
        if (element.can_disable == true) {
          var element_disabled;
          element.disabled_condition.forEach((o: any) => {
            let x = this.filterData.filter((i: any) => {
              const control = this.filterForm.get(i.control);
              if (control) {
                let y = control.value
                return (o.control == i.control && o.value.includes(y));
              }
            });
            if (x && x.length > 0) {
              element_disabled = true;
            }
          });
          if (this.filterForm.get(element.control)) {
            const control = this.filterForm.get(element.control);
            if (element_disabled === true) {
              element.disabled = true;
              if (control) {
                control.disable();
              }
              /** Set default value after disabled */
              this.filterForm.controls[element.control].setValue(element.default);
            } else {
              if (control) {
                control.enable();
              }
            }
          }
        }
        // Opt-in only (can_hide/hide_condition) - existing filters that don't
        // set these are completely unaffected. Same shape/mechanism as
        // can_disable/disabled_condition above, but drives *ngIf visibility
        // instead of the form control's enabled state, so a field can be
        // removed from the panel entirely (not just grayed out) based on
        // another field's live value, without waiting for Apply.
        if (element.can_hide == true) {
          var element_hide;
          element.hide_condition.forEach((o: any) => {
            let x = this.filterData.filter((i: any) => {
              const control = this.filterForm.get(i.control);
              if (control) {
                let y = control.value
                return (o.control == i.control && o.value.includes(y));
              }
            });
            if (x && x.length > 0) {
              element_hide = true;
            }
          });
          element.hide = element_hide === true;
        }
      });
    }
  }

  mindateFilter: any = this.route.snapshot.queryParams['startDate'] ? new Date(this.route.snapshot.queryParams['startDate']) : new Date(2024, 0, 1);
  maxDateFilter: any = new Date(this._shared.getMaxDate(this._local.customGetItem("timezone")))

  applyFilter(): void {
    // Use getRawValue so disabled controls (e.g. a sub-industry control that
    // was briefly disabled while options were being refreshed) still contribute
    // their selected value to the emitted payload.
    const formValue = this.filterForm.getRawValue();
    if (formValue && formValue.search) {
      formValue.search = formValue.search.trim();
    }
    this.finalValues.emit({ data: formValue });
  }

  resetAll(): void {
    this.initForm(0);
    this.resetAllFilters.emit({ data: this.filterForm.getRawValue() });
    this.applyFilter();
  }

  async filterOnChange(eventName: string, data: any) {
    if (eventName == "" || !eventName) {
      return;
    }
    switch (eventName) {
      case "industryFilter":
        const industries: any = []
        data.forEach((item: any) => {
          industries.indexOf(item.data.value) === -1 ? industries.push(item.data.value) : 0;
        });
        this.filterData.forEach(async element => {
          if (element.control == "subIndustryFilter") {
            if (industries.length) {
              let subIndustries: any = await this.getSubIndustryList(industries);
              this.cd.detectChanges();
              element.options = subIndustries.map((element: any) => {
                return {
                  value: element.doctor_speciality,
                  label: element.speciality_name
                }
              });
              this.filterForm.get(element.control)?.enable();
            } else {
              element.options = []
            }
          }
        });
        break;
    }
    return;
  }

  getSubIndustryList(industries: any) {
    return new Promise(async (resolve, reject) => {
      let data = {
        industry_filter: industries
      };
      this._api.api(data, 'business/get_specialities')
        .subscribe((data: any) => {
          if (data && !data.is_error) {
            if (data && data.data) {
              data.data.forEach((item: any, index: any) => {
                item.doctor_speciality = item.doctor_speciality.toString();
              });
              resolve(data.data);
            }
          }
        }, (error: any) => {
          resolve([]);
          console.log(error);
        });
    });
  }

  cancelSearch() {
    this.cancelSearched.emit({ title: 'cancel search' });
  }
  onOpenCalendar(container: any) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('month');
  }

  /** ------------------ Score Range (native select, same UI as dropdown filters) ------------------ */
  getScoreRangeValue(field: any): { min: any; max: any } {
    const raw = this.filterForm?.get(field.control)?.value;
    if (raw && typeof raw === 'object') {
      return {
        min: raw.min === undefined || raw.min === '' ? null : raw.min,
        max: raw.max === undefined || raw.max === '' ? null : raw.max,
      };
    }
    return { min: null, max: null };
  }

  getScoreRangeIndex(field: any): number {
    const v = this.getScoreRangeValue(field);
    const norm = (x: any) => (x === null || x === undefined || x === '') ? null : Number(x);
    const min = norm(v.min);
    const max = norm(v.max);
    if (field.options && field.options.length) {
      const idx = field.options.findIndex((opt: any) => norm(opt.min) === min && norm(opt.max) === max);
      return idx >= 0 ? idx : 0;
    }
    return 0;
  }

  setScoreRangeByIndex(field: any, index: number): void {
    const opt = field.options?.[index];
    if (opt) {
      this.filterForm.get(field.control)?.setValue({ min: opt.min, max: opt.max });
    }
  }
}